import 'ShopUiBundle/components/molecules/basic-modal';
import './video-player.scss';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('video-player', () => import(/* webpackMode: "lazy" */'./video-player'));
